var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-8 pt-20"},[_c('h1',{staticClass:"font-bold uppercase mb-4 text-2xl"},[_vm._v("Devices")]),_c('CreateDeviceForm'),_c('DevicesTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }